import { Box } from '@mui/material';

export function NewTag() {
  return (
    <Box
      component="span"
      sx={{
        backgroundColor: 'primary.main',
        color: '#fff',
        fontSize: 9,
        fontWeight: 500,
        textTransform: 'uppercase',
        letterSpacing: '0.4px',
        padding: '1px 5px',
        borderRadius: 1,
        lineHeight: '14px',
        flexShrink: 0,
      }}
    >
      New
    </Box>
  );
}
